import React from "react";

function ErrorPage () {
    return(
        <div>
            <h1 className="error-heading">
                ERROR 404
            </h1>
            <p className="error-paragraph">
                Web page you are trying to access isnt fully set up at the moment.
            </p>
        </div>
    );
}

export default ErrorPage